import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { clientShape } from '../../clients/propTypes';
import ClientRailItem from './components/ClientRailItem';
import List from './styled';

const ARROW_OFFSET = {
  ArrowUp: -1,
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowRight: 1
};

const ClientRail = ({ clients, value, onChange }) => {
  const intl = useIntl();
  const itemRefs = useRef({});
  const shouldFocus = useRef(false);

  useEffect(() => {
    if (!shouldFocus.current) return;

    shouldFocus.current = false;
    const activeItem = itemRefs.current[value];
    if (activeItem) activeItem.focus();
  }, [value]);

  const selectAt = (index) => {
    const nextIndex = (index + clients.length) % clients.length;
    shouldFocus.current = true;
    onChange(clients[nextIndex].id);
  };

  const handleKeyDown = (event) => {
    const currentIndex = clients.findIndex(({ id }) => id === value);
    const offset = ARROW_OFFSET[event.key];

    if (offset) {
      event.preventDefault();
      selectAt(currentIndex + offset);
    } else if (event.key === 'Home') {
      event.preventDefault();
      selectAt(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      selectAt(clients.length - 1);
    }
  };

  const registerRef = (id) => (node) => {
    itemRefs.current[id] = node;
  };

  return (
    <List
      aria-label={ intl.formatMessage({ id: 'mcp.rail.ariaLabel' }) }
      aria-orientation="vertical"
      onKeyDown={ handleKeyDown }
      role="tablist"
    >
      {clients.map((client) => (
        <ClientRailItem
          key={ client.id }
          client={ client }
          isActive={ client.id === value }
          onSelect={ onChange }
          ref={ registerRef(client.id) }
        />
      ))}
    </List>
  );
};

ClientRail.propTypes = {
  clients: PropTypes.arrayOf(clientShape).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ClientRail;
